import { BUTTON_IDS } from "../stores/useGame";

/**
 * Обрабатывает действия кнопок на основе текущего состояния
 * @param {Object} state - состояние из useGame store
 * @returns {boolean} - true если действие было выполнено, false если нет активных кнопок
 */
export const handleButtonActions = (state) => {
  if (state.buttonStates[BUTTON_IDS.TELEGRAM]) {
    window.open("https://t.me/Sv9tich", "_blank");
    return true;
  } else if (state.buttonStates[BUTTON_IDS.LINKEDIN]) {
    window.open("https://www.linkedin.com/in/stan-mitusov/", "_blank");
    return true;
  } else if (state.buttonStates[BUTTON_IDS.EMAIL]) {
    window.open("mailto:muutupss@gmail.com", "_blank");
    return true;
  } else if (state.buttonStates[BUTTON_IDS.BOSTONGENE]) {
    window.open("https://bostongene.com", "_blank");
    return true;
  } else if (state.buttonStates[BUTTON_IDS.SBERTECH]) {
    window.open(
      "https://platformv.sbertech.ru/products/other/syn-ai",
      "_blank"
    );
    return true;
  } else if (state.isStartButtonActive) {
    state.start();
    return true;
  }

  return false;
};
